<template>
  <div class="sealAndName">
    <div class="wrap">
      <div class="header">
        放置签名/签章
        <div class="icon" @click="close">收起</div>
      </div>
      <div class="sealContent">
        <!-- 签名 -->
        <div class="des">点击签名或拖拽至需要签署的位置</div>
        <ul class="signList" id="signList">
          <template>
            <li v-for="(item, index) in signList" :key="index" class="nameImg-item"
              @touchstart="touchStart($event, item)" @touchmove="touchMove($event)" @touchend="touchEnd($event, item)">
              <img class="" :src="base64Url(item.signImg)" alt="" />
            </li>
          </template>
          <li v-if="canAddSign" class="nameImg-item add-user-sign" @click="addSignName">
            <SvgIcon type="add" class="add-sign-icon" />
            <span class="add-sign-text">添加签名</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      sealData: null,
      li: null,
      position: {
        x: 0,
        y: 0,
      },
      touchPosition: {
        x: 0,
        y: 0,
      },
      left: 0,
      top: 0,
      isEnd: false,
    }
  },
  computed: {
    ...mapState({
      signInfo: state => state.sign,
      hideSeal: state => state.sign.hideSeal,
      canAddSign: state => state.sign.canAddSign,
    }),
    signList() {
      return this.signInfo.signList
    },
    wrapWidth() {
      const imgWrap = document.getElementsByClassName('fileList')[0]
      const { width } = imgWrap.getBoundingClientRect()
      return width
    },
    ratio() {
      return this.wrapWidth / 595
    },
  },
  methods: {
    addSignName() {
      this.$router.push({
        path: '/addSignNamePage',
        query: {
          flowId: this.signInfo.flowId,
        },
      })
    },
    base64Url(url) {
      return `data:image/png;base64,${url}`
    },
    close() {
      this.$emit('close')
    },
    touchStart(e, item) {
      this.sealData = item
      e.preventDefault()
      let el = e.target
      const element = e.targetTouches[0]
      if (
        e.target.getAttribute('class') !== 'nameImg-item' ||
        e.target.getAttribute('class') !== 'sealImg-item'
      ) {
        el = e.target.parentNode
      }
      this.li = el.cloneNode(true)
      this.touchPosition.x = element.clientX
      this.touchPosition.y = element.clientY
      this.position.x = el.getBoundingClientRect().left
      this.position.y = el.getBoundingClientRect().top
      this.left = el.getBoundingClientRect().left
      this.top = el.getBoundingClientRect().top
      let w = item.width
      let h = item.height

      if (w > 160 || h > 160) {
        if (w > h) {
          h = (160 * h) / w
          w = 160
        } else {
          w = (160 * w) / h
          h = 160
        }
      }
      this.sealData.width = w
      this.sealData.height = h
      w = w * this.ratio * 0.75
      h = h * this.ratio * 0.75

      this.li.style.cssText = `position: fixed;left: ${this.position.x
        }px; top: ${this.position.y}px;
        width:${w}px;
        height:${h}px`
      document.body.appendChild(this.li)
      document.querySelector('#app').style.overflow = 'hidden'
    },
    touchMove(e) {
      const element = e.targetTouches[0]
      this.left = this.position.x + element.clientX - this.touchPosition.x
      this.top = this.position.y + element.clientY - this.touchPosition.y
      if (Math.abs(element.clientY - this.touchPosition.y) > 50) {
        this.isEnd = true
      } else {
        this.isEnd = false
      }
      this.li.style.left = `${this.left}px`
      this.li.style.top = `${this.top}px`
      const height =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      this.top += height - 68
      this.sealShow = false
    },
    touchEnd(e) {
      document.querySelector('#app').style.overflow = 'visible'
      if (!this.li) return
      document.body.removeChild(this.li)
      console.log("🚀 ~ touchEnd ~ !this.isEnd:", this.sealData)
      if (!this.isEnd) {
        // 点击触发
        this.setPosition(this.sealData)
      } else {
        this.onDrop(this.left, this.top, this.sealData)
      }
    },
    setPosition(sealData) {
      this.$emit('setPosition', sealData)
    },
    onDrop(getX, getY, sealData) {
      this.$emit('onDrop', getX, getY, sealData)
    },
  },
}
</script>
<style lang="less">
.nameImg-item {
  z-index: 1000;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="less" scoped>
.sealAndName {
  // border-top: 1px solid #e7e7e7;
  border-radius: 7px 7px 0px 0px;

  .header {
    width: 100vw;
    height: 59px;
    border: 1px solid #f5f5f5;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: bold;
    text-align: center;
    color: #111a34;
    background: #fff;
    line-height: 59px;
    letter-spacing: 0px;
    position: relative;
    border-radius: 7px 7px 0 0;
    box-shadow: 0px -10px 10px 0px rgba(88, 88, 88, 0.44);

    .icon {
      position: absolute;
      right: 16px;
      top: 20px;
      width: 36px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: right;
      color: #666666;
      line-height: 20px;
      flex-shrink: 0;
    }
  }

  .sealContent {
    min-height: 154px;
    padding: 0 16px;
    position: relative;

    .des {
      width: 100%;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      color: #677283;
      line-height: 20px;
      margin-top: 13px;
    }

    .signList {
      display: flex;
      flex-wrap: wrap;
      padding: 20px 8px 24px;
      width: 100%;
      gap: 12px;
      z-index: 20;

      .nameImg-item {
        position: relative;
        flex: 0 0 calc(25% - 9px);
        width: calc(25% - 9px);
        aspect-ratio: 1;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #e2e4ea;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0;

        img {
          width: 100%;
          height: 100%;
          -o-object-fit: scale-down;
          object-fit: scale-down;
          border-radius: 4px;
        }
      }

      .add-user-sign {
        position: relative;
        flex: 0 0 calc(25% - 9px);
        width: calc(25% - 9px);
        aspect-ratio: 1;
        border-radius: 4px;
        border: 1px dashed #c1c4cd;
        font-size: 14px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .add-sign-icon {
          font-size: 14px;
        }

        .add-sign-text {
          margin-top: 8px;
          color: #969799;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
